import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

const TOKEN_KEY = "m365_sig_token";
const USER_KEY = "m365_sig_user";

// sessionStorage: token dies with the tab, never shared across tabs/restarts.
export const authStore = {
  getToken: () => sessionStorage.getItem(TOKEN_KEY),
  getUser: () => {
    const raw = sessionStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  },
  setToken: (token) => sessionStorage.setItem(TOKEN_KEY, token),
  setUser: (user) => sessionStorage.setItem(USER_KEY, JSON.stringify(user)),
  clear: () => {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
  },
};

// Purge credentials persisted by older builds in localStorage.
localStorage.removeItem(TOKEN_KEY);
localStorage.removeItem(USER_KEY);

api.interceptors.request.use((cfg) => {
  const token = authStore.getToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Skip auto-logout for endpoints where 401 signals a business rule
      // (e.g. wrong current password on profile update) instead of session expiry.
      const url = err?.config?.url || "";
      const isBusinessAuthError = url.includes("/auth/profile");
      if (!isBusinessAuthError && authStore.getToken()) {
        authStore.clear();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;

/**
 * Normalize an axios/FastAPI error into a human-readable message.
 * Handles FastAPI 422 responses whose `detail` is an array of validation errors.
 */
export function formatApiError(err, fallback = "Ocurrió un error") {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(", ") || fallback;
  }
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object") return detail.msg || fallback;
  return err?.message || fallback;
}
